import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

// Create the context
const HealthContext = createContext();

// Custom hook to use the Health context
export const useHealth = () => {
  const context = useContext(HealthContext);
  if (!context) {
    throw new Error('useHealth must be used within a HealthProvider');
  }
  return context;
};

// Health Provider component
export const HealthProvider = ({ children }) => {
  // State variables (add more as needed)
  const [loading, setLoading] = useState(false);
  const [habits, setHabits] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());

  // Functions (add more as needed)
  const resetHealth = () => {
    setHabits([]);
    setSelectedDate(new Date());
  };

  // Context value
  const value = {
    // States
    loading,
    habits,
    selectedDate,

    // State setters
    setLoading,
    setHabits,
    setSelectedDate,

    // Functions
    resetHealth
  };

  return <HealthContext.Provider value={value}>{children}</HealthContext.Provider>;
};

HealthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default HealthContext;
